package com.shadowings.gero.data.lessons.chapter5
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter2.animalNames
import com.shadowings.gero.data.lessons.chapter2.foodNames
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter2.humanNames
import com.shadowings.gero.data.lessons.chapter3.vocabVarieWords
import com.shadowings.gero.data.lessons.chapter4.royalNameWordIds
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_chap5_alyn_1
import gero.composeapp.generated.resources.exp_content_chap5_alyn_2
import gero.composeapp.generated.resources.exp_content_chap5_nilo_1
import gero.composeapp.generated.resources.exp_content_chap5_nilo_2
import gero.composeapp.generated.resources.exp_content_chap5_nilo_3
import gero.composeapp.generated.resources.exp_title_chap5_intro

fun getHieroVerbs1Content(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_chap5_intro,
            content = Res.string.exp_content_chap5_nilo_1,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_chap5_intro,
            content = Res.string.exp_content_chap5_alyn_1,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_chap5_intro,
            content = Res.string.exp_content_chap5_nilo_2,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_chap5_intro,
            content = Res.string.exp_content_chap5_alyn_2,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_chap5_intro,
            content = Res.string.exp_content_chap5_nilo_3,
            face = Faces.Serious,
            character = Characters.Nilo,
        )
    )

    val previous =
        (famousNames + foodNames + animalNames + humanNames + vocabVarieWords + royalNameWordIds).toHieroList(
            words
        )
    val current = vocabVerbs1WordIds.toHieroList(words)


    return intro + current.filter { it !in previous }.toHieroExplanation(hiero, languageCode).map {
        return@map it.copy(
            character = Characters.Nilo
        )
    }
}

fun getHieroVerbs1QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val previousContent = getHieroFoodContent(hiero, words, languageCode) +
            getHieroAnimalsContent(hiero, words, languageCode) +
            getHieroHumansContent(hiero, words, languageCode)
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getHieroVerbs1Content(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = previousContent
    )
}


